<script setup lang="ts">
import { computed } from 'vue';
import { RouterLink, type RouteLocationRaw } from 'vue-router';

const props = defineProps<{ to?: RouteLocationRaw }>();

const tag = computed(() => (props.to ? RouterLink : 'div'));
</script>

<template>
  <component
    :is="tag"
    :to="to"
    class="raya-card"
  >
    <slot />
  </component>
</template>
